/* predator-lander-fix4.js
 * Branch LANDER-FIX-4. Additive. Loaded AFTER predator-lander-fix3.js.
 *
 * Bon, after LANDER-FIX-3 went live, with screenshots:
 *
 *  (a) "at 430 wide the section 16 IN THE BOX flat lay is still broken: the
 *       CORE column items are fine but the manual card renders huge over the
 *       FLIP-TO-SIDE column, the FULL LOADOUT / TAP AN ITEM TO ADD IT label
 *       prints on top of the items, and the 13mm lens sprite is half off the
 *       left edge."
 *
 *  (b) "the section 03 picatinny 1913 rail and dovetail callout leader line
 *       still shoots off to the LEFT of the screen on both phone and desktop:
 *       the green line starts at the eyecup on the image and runs down left off
 *       the image instead of ending at the text box below it."
 *
 * WHAT LANDER-FIX-3 GOT WRONG, AND WHY
 *
 * (a) fix3 scaled every sprite carrying data-no="s16-sprite-wrap". Measured on
 *     the live page there are NINE sprites in section 16 and only THREE carry
 *     that attribute. The other six are bare divs with hard coded inline pixels
 *     and no wrapper, so fix3 never saw them. Two of those six are 232px and
 *     231px wide inside an 83.5px cell and, being centred, paint from x = -54.
 *     One of them is the manual card, 179 x 200 in the same 83.5px cell. This
 *     file finds sprites by what they ARE (a div with an inline width and an
 *     inline background-image inside section 16) rather than by an attribute
 *     only some of them happen to carry.
 *
 * (b) fix3 measured and fixed a DIFFERENT callout. Bon's words name section 03,
 *     but his screenshot is the "It speaks dovetail" block, which the page
 *     labels 08 / MOUNTING ECOSYSTEM. fix3's eduConnector work was on the
 *     "Without night vision or thermal, our eyes see nothing" callout over
 *     #edu-image, which is a real and separate element. Both were disconnected;
 *     fix3 joined up the one it found. This file joins up the one in the
 *     screenshot, and leaves fix3's alone.
 *
 * MEASURED ON THE LIVE PAGE BEFORE THIS FILE (headless Chrome, real Chrome
 * channel, https://nightoperators.com/products/predator-thermal-monocular):
 *
 *   section 16 flat lay sprites at 430 (nat px -> rendered px in an 83.5px cell)
 *     a0 232x128 at x = -54.3   OFF THE LEFT EDGE, collides with a1
 *     a1  60x132 at x = 131.1
 *     a2  94x94  at x =  15.0   bursts its cell by 10
 *     a3  58x153 at x = 132.4
 *     a4 231x109 at x = -53.6   OFF THE LEFT EDGE, collides with a5
 *     a5 179x200 at x =  71.5   the manual card, bursts its cell by 96
 *     a6/a7/a8 already scaled by fix3
 *   Identical at 390. At 768 a0 and a4 still start at x = -5 and -4.4.
 *   Three labels print over a5 at 390 and 430: FREE, FULL LOADOUT,
 *   "Tap an item to add it".
 *
 *   section 08 mount leader, at every width:
 *     <svg class="absolute inset-0 w-full h-full" (NO viewBox)>
 *       <line x1="82" y1="729" x2="640" y2="442.671875">
 *       <circle cx="640" cy="442.671875" r="4">
 *     The svg box is 200.9px tall at 390, 430 and 768, and 322.5px at 2000.
 *     With no viewBox, user units are CSS pixels of that box, so BOTH endpoints
 *     sit several hundred pixels below it and the dot is 210px past its right
 *     edge at 430. overflow-visible means it paints rather than clips.
 *
 * WHAT THIS FILE DOES
 *
 *   Fault A: measures every sprite's natural inline size and its real cell,
 *   computes the scale that fits, writes --no-s16-fit, and writes the row
 *   height the scaled art actually needs so labels never sit on items.
 *
 *   Fault B: rewrites the mount leader's line and dot from real rectangles:
 *   it starts at the anchor point the art already marks on the image and ends
 *   ON the text box below it, recomputed on layout and on resize.
 *
 * It changes no price, no cart payload, no kit behaviour and no copy. It writes
 * geometry only.
 */
(function () {
  'use strict';

  var root = document.getElementById('no-predator');
  if (!root) return;
  if (root.hasAttribute('data-no-fix4')) return;
  root.setAttribute('data-no-fix4', '1');

  var NS = 'http://www.w3.org/2000/svg';

  function $$(sel, el) {
    return Array.prototype.slice.call((el || root).querySelectorAll(sel));
  }
  function num(v) { return Math.round(v * 10) / 10; }
  function rect(el) { return el.getBoundingClientRect(); }

  /* ================================================================== *
   * FAULT A. SECTION 16 FLAT LAY.
   *
   * Find sprites structurally, not by an attribute. A flat lay sprite is a div
   * that carries BOTH an inline width in pixels and an inline background-image,
   * and lives inside [data-no="s16"]. That description matches all nine, the
   * three fix3 already handles included, so this is a superset of fix3's set
   * and the two agree on those three (both compute a fit-to-cell scale, and
   * whichever runs last wins with the same number).
   * ================================================================== */

  function spriteArts() {
    var s16 = root.querySelector('[data-no="s16"]');
    if (!s16) return [];
    return $$('div', s16).filter(function (d) {
      if (!d.style) return false;
      if (!d.style.backgroundImage || d.style.backgroundImage === 'none') return false;
      var w = parseFloat(d.style.width);
      if (!(isFinite(w) && w > 0)) return false;
      // LEAVE THE THREE SPRITES LANDER-FIX-3 ALREADY OWNS ALONE.
      //
      // fix3 scales anything under [data-no="s16-sprite-wrap"] against a cell
      // it measures from that wrapper. Those three were measured correct on the
      // live page at every width (a6 74x42, a7 74x62, a8 64x67 in cells of
      // 195.2, 125.9 and 72.1 at 430). If fix4 also scaled them it would
      // measure a DIFFERENT ancestor (the wrapper, not the grid cell), compute
      // a larger scale, and blow them back out: measured, doing so pushed a6 to
      // 183.2px ending at x = 425.2 in a 430 viewport. Two owners, one number,
      // is a bug generator. fix4 takes only the six fix3 cannot see.
      if (d.closest && d.closest('[data-no="s16-sprite-wrap"]')) return false;
      return true;
    });
  }

  /* The cell an art must fit inside.
   *
   * The markup is: column > item > art, where "item" is the fixed height
   * centring box (class "relative flex items-center justify-center") and
   * "column" is the flex-col that also holds the label. The width that
   * constrains the art is the COLUMN's, because the item box is sized by its
   * own oversized child and so is useless as a measurement. Walking up to the
   * column is therefore load bearing: measuring the item box would report the
   * art's own width back at us and compute a scale of 1.
   */
  function artCell(art) {
    var item = art.parentElement;
    if (!item) return null;
    var col = item.parentElement;
    if (!col) return null;
    return { item: item, col: col };
  }

  function tagS16() {
    var arts = spriteArts();
    for (var i = 0; i < arts.length; i++) {
      var art = arts[i];
      var c = artCell(art);
      if (!c) continue;
      if (art.getAttribute('data-no-fix4') !== 'art') art.setAttribute('data-no-fix4', 'art');
      if (c.item.getAttribute('data-no-fix4') !== 'cell') c.item.setAttribute('data-no-fix4', 'cell');
      if (c.col.getAttribute('data-no-fix4') !== 'col') c.col.setAttribute('data-no-fix4', 'col');
      // every sibling of the item inside the column is a label
      var kids = Array.prototype.slice.call(c.col.children);
      for (var k = 0; k < kids.length; k++) {
        if (kids[k] === c.item) continue;
        if (kids[k].getAttribute('data-no-fix4') !== 'label') {
          kids[k].setAttribute('data-no-fix4', 'label');
        }
      }
    }
    tagColumnHeads();
  }

  /* The "FULL LOADOUT" / "TAP AN ITEM TO ADD IT" block that printed over the
   * items. It is the heading that sits immediately above the item grid inside a
   * [data-no="s16-col"]. We find it by walking the column's children and taking
   * everything before the first grid, which is the sprite row. */
  function tagColumnHeads() {
    var cols = $$('[data-no="s16-col"]');
    for (var i = 0; i < cols.length; i++) {
      var kids = Array.prototype.slice.call(cols[i].children);
      for (var k = 0; k < kids.length; k++) {
        var disp = '';
        try { disp = getComputedStyle(kids[k]).display; } catch (e) { disp = ''; }
        if (disp.indexOf('grid') >= 0) break; // reached the item row, stop
        if (kids[k].getAttribute('data-no-fix4') !== 'colhead') {
          kids[k].setAttribute('data-no-fix4', 'colhead');
        }
      }
    }
  }

  function fitS16() {
    var arts = spriteArts();
    for (var i = 0; i < arts.length; i++) {
      var art = arts[i];
      var c = artCell(art);
      if (!c) continue;

      // Natural size from the INLINE style, never from the rendered rect: the
      // rect already carries whatever scale a previous pass applied, so reading
      // it would compound the scale on every resize.
      var natW = parseFloat(art.style.width);
      var natH = parseFloat(art.style.height);
      if (!isFinite(natW) || natW <= 0) continue;
      if (!isFinite(natH) || natH <= 0) natH = natW;

      var cell = rect(c.col).width;
      if (cell <= 0) continue;

      // Leave a gutter so two neighbours can never touch even after rounding.
      //
      // 6px, not 12. The gutter is a flat subtraction, so on a phone where the
      // column is only 83.5px wide it is charged entirely to the widest art:
      // at 12px the PREDATOR UNIT sprite came out visibly smaller than the RAIL
      // ADAPTER beside it, which reads as a scaling bug rather than a fix. 6px
      // is still more than a rounding error and the columns are clipped by the
      // stylesheet regardless, so nothing can escape even if this were zero.
      var avail = cell - 6;
      if (avail < 24) avail = Math.max(16, cell * 0.9);

      var scale = avail / natW;
      if (scale > 1) scale = 1;      // never enlarge past the authored art
      if (scale < 0.12) scale = 0.12; // and never vanish

      /* PDP-SPEED 2026-09-04: same no-op write suppression as fix3, in the file
         that owns the OTHER six sprites. This file registers its own
         MutationObserver on [data-no="s16"] with attributeFilter including
         'style', and fitS16 writes into that subtree, so it re-arms itself in
         exactly the same way. The value is unchanged; only the redundant write
         is skipped. */
      var _fit = String(Math.round(scale * 1000) / 1000);
      if (art.style.getPropertyValue('--no-s16-fit') !== _fit) {
        art.style.setProperty('--no-s16-fit', _fit);
      }

      // The item box is a fixed 200px row. Once the art is smaller than that
      // the row is mostly empty space, which is what separated a label from its
      // item and let a tall neighbour reach across. Give the row the height the
      // scaled art actually needs, floored so a tiny sprite still has a row.
      var need = Math.ceil(natH * scale) + 12;
      if (need < 56) need = 56;
      if (need > 200) need = 200;
      c.item.style.setProperty('--no-s16-cellh', need + 'px');

      // The row height has to be written INLINE, not left to the stylesheet.
      // Measured: the item box carries style="height:200px" straight from the
      // Lovable build, and an inline declaration beats every stylesheet rule
      // regardless of selector specificity, so the CSS `height: var(...)` rule
      // never applied and the row stayed 200px tall with the art floating in
      // the middle of it. Setting the property on the element is the only way
      // to win against another inline value. The custom property above is kept
      // so the stylesheet still carries a correct fallback and so a test can
      // read the intended number without re-deriving it.
      //
      // Only ever SHRINK the row. Growing one would push the section's own
      // layout around, which is not this branch's business.
      // Remember the AUTHORED height the first time we see this element, and
      // always compare against that remembered value. Comparing against the
      // live inline height would compare against our own last write, so on a
      // resize back to a wider viewport the row could never grow again and the
      // art would sit in a row two sizes too small.
      var saved = c.item.getAttribute('data-no-fix4-h0');
      var authored;
      if (saved === null) {
        authored = parseFloat(c.item.style.height);
        c.item.setAttribute('data-no-fix4-h0', isFinite(authored) ? String(authored) : 'auto');
      } else {
        authored = saved === 'auto' ? NaN : parseFloat(saved);
      }
      if (!isFinite(authored)) c.item.style.height = need + 'px';
      else c.item.style.height = Math.min(need, authored) + 'px';
    }
  }

  /* ================================================================== *
   * FAULT B. SECTION 08 MOUNTING LEADER.
   *
   * Identify it by shape, because it carries no id and no data attribute: an
   * SVG with NO viewBox, absolutely positioned over its block, holding exactly
   * one <line> and one <circle>. That is a precise description of this overlay
   * and of nothing else in the lander (checked live: the only other bare-shape
   * SVGs are lucide icons, which are 24x24, DO carry a viewBox, and hold paths).
   * ================================================================== */

  function mountSvg() {
    var svgs = $$('svg');
    for (var i = 0; i < svgs.length; i++) {
      var s = svgs[i];
      if (s.getAttribute('viewBox')) continue;      // the icons all have one
      var line = s.querySelector('line');
      var circ = s.querySelector('circle');
      if (!line || !circ) continue;
      if (rect(s).width < 80) continue;             // not an overlay
      return { svg: s, line: line, circle: circ };
    }
    return null;
  }

  /* The text box the leader must reach: the bordered panel in the same block
   * that carries the dovetail copy. Found by its accent left border plus its
   * text, so a class rename alone cannot silently orphan it. */
  function mountTextBox(scope) {
    /* main 2026-09-04 (real clock 19:5x): on the live page no element carries the literal class
       "border-l-accent" (the panel's left rule is a Tailwind arbitrary class), so this returned null on every
       real browser and the leader was never placed. Read the COMPUTED left border instead, which is what the
       eye sees, and keep the text test so a class rename cannot orphan it. */
    var cands = $$('div', scope);
    var best = null;
    for (var i = 0; i < cands.length; i++) {
      var e = cands[i];
      var t = e.textContent || '';
      if (t.indexOf('1913') < 0 && t.indexOf('dovetail') < 0) continue;
      var r = rect(e);
      if (r.width <= 0 || r.height < 40 || r.height > 700) continue;
      var cs = window.getComputedStyle(e);
      var bw = parseFloat(cs.borderLeftWidth) || 0;
      if (bw <= 0 || cs.borderLeftStyle === 'none') continue;
      if (!best || r.height < rect(best).height) best = e;   // the tightest bordered box wins
    }
    return best;
  }

  /* Where the leader should START.
   *
   * The authored line begins at (82, 729), which is meaningless in this box.
   * What it is trying to point at is a spot on the photograph above the text
   * box. We anchor to a fraction of the IMAGE's own rectangle rather than to a
   * pixel, so the anchor tracks the image at every width instead of drifting.
   * The fractions below put it on the eyecup end of the unit, which is where
   * Bon says the line starts today and is the part of the art the callout is
   * about.
   */
  var ANCHOR_FX = 0.30;  // 30 percent across the image
  var ANCHOR_FY = 0.62;  // 62 percent down it

  /* The photograph the leader starts on.
   *
   * Look inside the OVERLAY'S OWN HOST BLOCK, not the whole section. The
   * section holds four images (the close up, the top down, the helmet shot and
   * the bridged PVS-14 shot) and only the top down one is under this overlay.
   * Searching the section and taking the largest picked the helmet shot at some
   * widths, which would anchor the leader to a photograph in a different block.
   *
   * The image is lazy loaded and its .hero-cap wrapper collapses to height 0
   * until it arrives, so a zero height image is treated as "not there yet" and
   * the caller falls back rather than anchoring to a collapsed box. The
   * scheduled re-measurements pick it up once it lands.
   */
  function mountImage(host) {
    var imgs = $$('img', host);
    var best = null, bestA = 0;
    for (var i = 0; i < imgs.length; i++) {
      var r = rect(imgs[i]);
      if (r.width <= 0 || r.height <= 0) continue;
      var a = r.width * r.height;
      if (a > bestA) { bestA = a; best = imgs[i]; }
    }
    return best;
  }

  function placeMountLeader() {
    var m = mountSvg();
    if (!m) return;
    var svg = m.svg;

    if (svg.getAttribute('data-no-fix4') !== 'mount-svg') {
      svg.setAttribute('data-no-fix4', 'mount-svg');
      m.line.setAttribute('data-no-fix4', 'mount-line');
      m.circle.setAttribute('data-no-fix4', 'mount-dot');
    }

    // The block the overlay is stretched across. inset-0 means its own box IS
    // that block, so the svg's rect is the coordinate space we work in: with no
    // viewBox, one user unit is one CSS pixel of this box, measured from its
    // top left.
    var host = svg.parentElement;
    if (!host) return;
    var hb = rect(svg);
    if (hb.width <= 0 || hb.height <= 0) return;

    var block = host.closest ? (host.closest('section') || host) : host;
    var box = mountTextBox(block);
    if (!box) return;
    var bb = rect(box);
    if (bb.width <= 0) return;

    // Start point: on the photograph in this overlay's OWN block if it has
    // arrived, otherwise a sane point near the top of the overlay.
    var img = mountImage(host);
    var ib = img ? rect(img) : null;
    var sx, sy;
    if (ib && ib.width > 0 && ib.height > 0) {
      sx = ib.left + ib.width * ANCHOR_FX;
      sy = ib.top + ib.height * ANCHOR_FY;
    } else {
      sx = hb.left + hb.width * 0.32;
      sy = hb.top + 6;
    }

    // Keep the start inside the overlay box. The overlay is now overflow:hidden
    // (see the stylesheet), so a start point outside it would simply be cut
    // off, which is exactly the silent failure this branch exists to remove.
    var pad = 4;
    if (sx < hb.left + pad) sx = hb.left + pad;
    if (sx > hb.right - pad) sx = hb.right - pad;
    if (sy < hb.top + pad) sy = hb.top + pad;
    if (sy > hb.bottom - pad) sy = hb.bottom - pad;

    // End point: ON the text box. Aim at the nearest point of its top edge, so
    // the line comes DOWN to the box the way Bon describes it should, and clamp
    // that too so the dot is always drawn inside the overlay.
    var tx = sx;
    if (tx < bb.left + 16) tx = bb.left + 16;
    if (tx > bb.right - 16) tx = bb.right - 16;
    var ty = bb.top + 2;

    if (tx < hb.left + pad) tx = hb.left + pad;
    if (tx > hb.right - pad) tx = hb.right - pad;
    if (ty < hb.top + pad) ty = hb.top + pad;
    if (ty > hb.bottom - pad) ty = hb.bottom - pad;

    // Into the svg's own user units: subtract the box origin.
    var x1 = num(sx - hb.left), y1 = num(sy - hb.top);
    var x2 = num(tx - hb.left), y2 = num(ty - hb.top);

    m.line.setAttribute('x1', x1);
    m.line.setAttribute('y1', y1);
    m.line.setAttribute('x2', x2);
    m.line.setAttribute('y2', y2);
    m.circle.setAttribute('cx', x2);
    m.circle.setAttribute('cy', y2);

    svg.setAttribute('data-no-fix4-ready', '1');
  }

  /* ================================================================== *
   * driver
   * ================================================================== */

  var raf = null;
  function relayout() {
    if (raf) return;
    /* main 2026-09-04: a hidden or background tab never delivers a frame, and a page opened in a background
       tab (or measured from one) then never gets its leader or its sprites. A timer runs in every tab state
       and layout reads are safe inside it, so the pass is scheduled on a timer, not a frame. */
    raf = setTimeout(function () {
      raf = null;
      try { tagS16(); } catch (e) { }
      try { fitS16(); } catch (e) { }
      try { placeMountLeader(); } catch (e) { }
    });
  }

  relayout();
  /* main 2026-09-04 (real clock 20:0x): the first pass runs while the lander blocks far below the fold still
     measure 0 by 0 (lazy media, content-visibility), so mountSvg() finds nothing, the observer below is never
     armed, and the leader is placed only if something else happens to mutate section 16 later. Placement was
     therefore a coincidence of the visitor's scroll path. Retry on a short timer until the leader is marked,
     and re place on scroll (coalesced through the same raf) so late images cannot leave it stale. */
  var tries = 0;
  var retry = setInterval(function () {
    relayout();
    var placed = root.querySelector('svg[data-no-fix4="mount-svg"]');
    if ((placed && ++tries > 6) || tries > 60) clearInterval(retry);
    else if (!placed) tries++;
  }, 500);
  window.addEventListener('scroll', relayout, { passive: true });
  window.addEventListener('resize', relayout, { passive: true });
  window.addEventListener('orientationchange', relayout, { passive: true });
  window.addEventListener('load', relayout);
  if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
    document.fonts.ready.then(relayout).catch(function () { });
  }

  // The section 16 tier tabs re-render the sprite rows, and the mount image
  // settles late, so re-measure whenever either subtree mutates.
  if (window.MutationObserver) {
    var mo = new MutationObserver(function () { relayout(); });
    var s16 = root.querySelector('[data-no="s16"]');
    if (s16) {
      mo.observe(s16, {
        childList: true, subtree: true, attributes: true,
        attributeFilter: ['class', 'style', 'hidden']
      });
    }
    var ms = mountSvg();
    if (ms && ms.svg.parentElement) {
      mo.observe(ms.svg.parentElement, { childList: true, subtree: true });
    }
  }

  // Images and webfonts settle after first paint; a few nudges remove a whole
  // class of "right on reload, wrong on first load" bugs for no real cost.
  var t = [120, 400, 900, 1800, 3000];
  for (var j = 0; j < t.length; j++) setTimeout(relayout, t[j]);

  // exposed for the test harness only
  window.NOPredatorFix4 = {
    relayout: relayout,
    _spriteArts: spriteArts,
    _mountSvg: mountSvg
  };
})();
